import { Trans, useTranslation } from 'react-i18next';

import { privatePolicyPath, termsOfServicePath } from 'authOld/routes/routePaths';
import { IAuthDefaultData, ISetUpAccountForm, ITermsAndPrivacy } from 'authOld/types';
import { Field, Form } from 'coreOld/components';
import { LinkText } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';

import { Wrapper } from './setUpAccountFormStyle';
import { setUpAccountSchema } from './setUpAccountSchema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: ISetUpAccountForm) => void;
  authDefaultData: IAuthDefaultData;
  isAuthDefaultDataLoading: boolean;
  termsAndPrivacyChecked: ITermsAndPrivacy;
  onChange: (name: keyof ITermsAndPrivacy) => void;
}

const SetUpAccountFormView = ({
  isOpen,
  onClose,
  onSubmit,
  authDefaultData,
  isAuthDefaultDataLoading,
  termsAndPrivacyChecked,
  onChange,
}: IProps) => {
  const { t } = useTranslation();

  const beforeSubmitContent = (
    <Wrapper>
      <Field
        type={InputType.CHECKBOX}
        inputProps={{
          label: (
            <Trans
              i18nKey="messageAgreeToTerms"
              components={[<LinkText href={termsOfServicePath()} key="termsOfService" />]}
            />
          ),
          checked: termsAndPrivacyChecked?.terms,
          onChange: () => onChange('terms'),
        }}
      />
      <Field
        type={InputType.CHECKBOX}
        inputProps={{
          label: (
            <Trans
              i18nKey="messageAgreeToPolicy"
              components={[<LinkText href={privatePolicyPath()} key="privacyPolicy" />]}
            />
          ),
          checked: termsAndPrivacyChecked?.privacy,
          onChange: () => onChange('privacy'),
        }}
      />
    </Wrapper>
  );

  return (
    <Form<ISetUpAccountForm>
      isOpen={isOpen}
      onClose={onClose}
      title={t('titleSetUpAccount')}
      submitBtnLabel={t('buttonLabelSetUpAccount')}
      defaultValues={{
        email: authDefaultData?.email,
        firstName: authDefaultData?.firstName,
        lastName: authDefaultData?.lastName,
        company: authDefaultData?.companyName,
      }}
      onSubmit={onSubmit}
      disabledSubmit={!(termsAndPrivacyChecked?.terms && termsAndPrivacyChecked?.privacy)}
      beforeSubmitContent={beforeSubmitContent}
      loadedDefaultValues={!isAuthDefaultDataLoading}
      schema={setUpAccountSchema()}
    >
      <Field
        name="email"
        label={t('labelWorkEmail')}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
          disabled: true,
          editable: false,
          defaultValue: authDefaultData?.email,
        }}
      />
      <Field
        name="firstName"
        label={t('labelFirstName')}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
          disabled: isAuthDefaultDataLoading,
          editable: !isAuthDefaultDataLoading,
          autoFocus: !isAuthDefaultDataLoading,
        }}
      />
      <Field
        name="lastName"
        label={t('labelLastName')}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
          disabled: isAuthDefaultDataLoading,
          editable: !isAuthDefaultDataLoading,
        }}
      />
      <Field
        name="company"
        label={t('labelCompany')}
        type={InputType.TEXTFIELD}
        inputProps={{
          size: Size.LG,
          disabled: isAuthDefaultDataLoading || authDefaultData?.companyFixed,
          editable: !isAuthDefaultDataLoading && !authDefaultData?.companyFixed,
        }}
      />
    </Form>
  );
};

export default SetUpAccountFormView;
